import React from "react";
import s from "./MobileMenu.module.css";
import closePopup from "../../assets/img/mobile/close.png";
import classnames from "classnames";
import { NavLink, useNavigate } from "react-router-dom";
import {
  HOME,
  LOGIN,
  MOBILE_LEGAL_INFORMATION,
  OPEN_ACCOUNT,
} from "../../router/Constants";
import { publicRoutes } from "../../router/PublicRoutes";
import CustomBtnPink from "../ui/customBtnPink/CustomBtnPink";
import CustomBtnTransparent from "../ui/customBtnTransparent/CustomBtnTransparent";
import CustomBtnBlue from "../ui/customBtnBlue/CustomBtnBlue";
import { useTranslation } from "react-i18next";
import LanguageDropdown from '../ui/LanguageDropdown/LanguageDropdown'

type propsType = {
  isActive: boolean;
  setIsActive: (active: boolean) => void;
};

const MobileMenu = ({ isActive, setIsActive }: propsType) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const redirect = (link: string) => {
    navigate(link);
    setIsActive(false);
  };

  return (
    <div className={classnames(s.myPopup, isActive ? s.active : s.inactive)}>
      <div className={s.close_img_block}>
        <img
          src={closePopup}
          className={s.closeImg}
          alt=""
          onClick={() => setIsActive(false)}
        />
      </div>
      <LanguageDropdown />

      <div className={s.links_block}>
        <NavLink
          to={HOME}
          className={s.link}
          onClick={() => setIsActive(false)}
        >
          {t("mobileMenu.home")}
        </NavLink>
        {publicRoutes.map((item) => (
          <NavLink
            key={item.path}
            className={s.link}
            to={item.path}
            onClick={() => setIsActive(false)}
          >
            {t(item.titleKey)}
          </NavLink>
        ))}
        <NavLink
          to={MOBILE_LEGAL_INFORMATION}
          className={s.link}
          onClick={() => setIsActive(false)}
        >
          {t("mobileMenu.legalInformation")}
        </NavLink>
      </div>
      <div className={s.btns}>
        <div className={s.btn_block}>
          <CustomBtnBlue
            title={t("mobileMenu.openAccount")}
            onClick={() => redirect(OPEN_ACCOUNT)}
          />
        </div>
        <div className={s.btn_block}>
          <CustomBtnBlue
            title={t("mobileMenu.logIn")}
            onClick={() => redirect(LOGIN)}
          />
        </div>
      </div>
      <div className={s.mobile_menu_footer}>
        <div className={s.copyright}>{t("mobileMenu.copyright")}</div>
      </div>
    </div>
  );
};

export default MobileMenu;
